import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  return (
    <div className="container home-container">
      <div className="home-showcase my-2">
        <Link to="/editions">
          <img
            className="home-image"
            src="/img/uploads/new-work-sheila-hicks/hicks_cover.jpg"
            alt="Sheila Hicks Book"
          />
        </Link>
        <p className="large my-2">
          <Link to="/editions/66a0571e6e1850176a61c2c8">
            Sheila Hicks, <em>New Work</em>, 2024
          </Link>
        </p>
        <p>
          For nearly seven decades, Sheila Hicks has created groundbreaking
          works that redefine the expressive possibilities of fiber as a
          sculptural form. Based in Paris since 1964, she incorporates natural
          and synthetic materials at a range of scales from intimate weavings
          made on handheld frames to monumental installations that inhabit
          architecture. Inspired by objects, textures, and patterns observed in
          her adopted city or in her migratory life, she draws from places with
          personal significance in her work. Beacon-like comets of vivid
          intersecting and multilayered lines, small works that reflect her
          daily experiments, and massive mounds of fiber in vibrant colors draw
          from the cobblestones of her courtyard or the towering lighthouses of
          the rocky island of Ouessant, France.
        </p>
        <br />
        <p>
          This limited-edition artist book reflects Hicks’s first solo
          exhibition at the San Francisco Museum of Modern Art, a site-specific
          installation in the museum’s New Work gallery and expansive outdoor
          sculpture garden commission. Like the exhibition, this RITE Edition
          reveals how Hicks continually evolves materials and forms in a process
          she describes as “walking the tightrope into the future.”
        </p>

        <br />
        <p>
          Published on the occasion of the 2025-2026 exhibition curated by Marin
          Sarvé-Tarr, Assistant Curator of Painting and Sculpture, San Francisco
          Museum of Modern Art
        </p>
        <p>RITE Editions, publisher</p>
        <p>Colpa Press, San Francisco, printer</p>
        <p>Megan Gibes and Diane Newel, San Francisco, binding</p>
        <p>Ella Gold, design</p>
        <br />
        <p>Artist's Book</p>
        <p>Edition of 300</p>
        <p>Exposed sewn binding with embossed board cover</p>
        <p>116 pages</p>
        <p>6 x 9"</p>
        <p>
          <strong>$60</strong>
        </p>
        <br />
        <p>Publication support from:</p>
        <ul>
          <li>- Sikkema Malloy Jenkins, New York </li>
          <li>- galerie frank elbaz, Paris</li>
          <li>- Alison Jacques, London</li>
          <li>- Sunbrella, North Carolina</li>
        </ul>

        {/* <p className='lead-sm'>
          RE publications will be available at the SFMOMA Small Press Book Bazaar,
          <strong> December 1st, 2022</strong>, 1–8 p.m.
        </p> */}
        {/* <p className='lead-sm my-1'>
          <a href='https://www.sfmoma.org/event/2022-small-press-book-bazaar/'>Click here for more information.</a>
        </p> */}

        <br />
        <p>
          To order a recent edition, <a href="/shop.html">visit our shop.</a>
        </p>
      </div>
      <div className="home-upcoming">
        {/* <p className='large'>New and Upcoming 2022-2023</p> */}
        <p className="lead-sm">
          <Link to="/editions">View More Editions →</Link>
        </p>
      </div>
    </div>
  );
};

export default Home;
